import keepTipsModal from './TipsModal.vue';
export default keepTipsModal;
